<p-messages key="info"></p-messages>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<div class="row">
    <div class="col-md-7">
        <h6 class="prd-h6">View E-File Applications</h6>
    </div>
    <div class="col-md-4 offset-1">
        <label for="calYear" style="padding-right: 10px;"><strong>Calendar Year:</strong></label>
        <select id="calYear" style="width: 150px;" title="Select a year" [(ngModel)]="myYear" class="form form-input" (change)="selectYear($event)">
            <option *ngFor="let yr of yearList" [ngValue]="yr">{{yr}}</option>
        </select>
        <button class="btn btn-success" style="margin-left: 10px;" (click)="getEfiledAppList()" title="Refresh list of E-File Applications">Refresh</button>
    </div>
</div>
<hr />
<div class="card" *ngIf='displayState.workingDiv'>
    <div class="card-body">
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>

<div class="card bg-light" [hidden]="displayState.workingDiv" style="margin-top: 5px;">
    <div class="card-body" style="margin-bottom: 3px;">
        <!-- Grid -->
        <div class="row" [hidden]="!displayState.indexDiv">
          <p-table #efileCases
                   [columns]="cols"
                   styleClass="p-datatable-striped p-datatable-gridlines"
                   [value]="applicationList"
                   [scrollable]="true"
                   [responsive]="true"
                   scrollHeight="400px"
                   [(selection)]="selectedCases"
                   dataKey="applicationId"
                   (onFilter)="onFilter($event, efileCases)"
                   [showCurrentPageReport]="true"
                   [rows]="5"
                   [rowsPerPageOptions]="[5, 10, 25, 50]"
                   [paginator]="false"
                   [resizableColumns]="true"
                   columnResizeMode="expand"
          >
            <ng-template pTemplate="caption">
              <div class="flex">
                <button pButton label="Clear Filters" class="p-button-outlined" (click)="clearTable(efileCases)"></button>
                <!-- <span class="p-input-icon-left ml-auto">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" (keyup.enter)="efileCases.filterGlobal($event.target.value, 'contains')" placeholder="Search keyword" />
              </span>
                &nbsp;&nbsp;
                <input pInputText type="text" (keyup.enter)="efileCases.filterGlobal($event.target.value, 'contains')" placeholder="Global Filter" title="Enter text for which to search, then press ENTER key" (keyup.enter)="efileCases.filterGlobal($event.target.value, 'contains')" style="width:200px;" />
                                  -->

                &nbsp;&nbsp;&nbsp;
                <strong>E-File Applications for {{this.myYear}}</strong>
              </div>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width: 6%;">{{ cols[0].header }}
                  <p-columnFilter type="date" field="dateUpdated" matchMode="equals" display="menu">
                  </p-columnFilter>
                </th>
                <th style="width: 11%;">{{ cols[1].header }}
                  <p-columnFilter type="text" field="username" matchMode="contains" display="menu">
                  </p-columnFilter>
                </th>
                <th style="width: 6%;">{{ cols[2].header }}
                  <p-columnFilter field="filingStatus" matchMode="in" display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-multiSelect [ngModel]="value" [options]="statuses" placeholder="Any" (onChange)="filter($event.value)">
                        <ng-template let-option pTemplate="item">
                          <div class="inline-block vertical-align-middle">
                            <span class="ml-1 mt-1">{{ option.label }}</span>
                          </div>
                        </ng-template>
                      </p-multiSelect>
                    </ng-template>
                  </p-columnFilter>
                </th>
                <th style="width: 6%;">{{ cols[8].header }}
                  <p-columnFilter field="typeOfAssessment" matchMode="in" display="menu">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-multiSelect [ngModel]="value" [options]="appealsTypeList" placeholder="Any" (onChange)="filter($event.value)">
                        <ng-template let-option pTemplate="item">
                          <div class="inline-block vertical-align-middle">
                            <span class="ml-1 mt-1">{{ option.label }}</span>
                          </div>
                        </ng-template>
                      </p-multiSelect>
                    </ng-template>
                  </p-columnFilter>
                </th>
                <th style="width: 10%;">{{ cols[3].header }}
                  <p-columnFilter type="text" field="applicantName" matchMode="contains" display="menu">
                  </p-columnFilter>
                </th>
                <th style="width: 5%;">{{ cols[4].header }}
                  <p-columnFilter type="text" field="parcelNumber" matchMode="contains" display="menu">
                  </p-columnFilter>
                </th>
                <th style="width: 15%;">{{ cols[5].header }}
                  <p-columnFilter type="text" field="propertyLocationView" matchMode="contains" display="menu">
                  </p-columnFilter>
                </th>
                <th style="width: 4%;">{{ cols[7].header }}
                  <p-columnFilter type="text" field="applicationNumber" matchMode="contains" display="menu">
                  </p-columnFilter>
                </th>
                <th style="width: 4%;"></th>
                <th style="width: 4%;"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-case>
              <tr>
                <td style="width: 6%;">{{ case.dateUpdated | date:"MM/dd/yyyy" }}</td>
                <td style="width: 11%" title="{{case.username}}"> {{case.username}}</td>
                <td style="width: 6%">{{case.filingStatus}}</td>
                <td style="width: 6%">{{case.typeOfAssessment}}</td>
                <td style="width: 10%;" title="{{case.applicantName}}">{{ case.applicantName }}</td>
                <td style="width: 5%;" title="{{case.parcelNumber}}">{{ case.parcelNumber }}</td>
                <td style="width: 15%;" title="{{case.propertyLocationView}}">{{ case.propertyLocationView }}</td>
                <td style="width: 4%;">{{ case.applicationNumber }}</td>
                <td style="width: 4%;"><button id="viewApp" type="button" title="View application details" class="btn btn-link btn-sm" (click)="viewApplication(case)">View App</button></td>
                <td style="width: 4%;"><button id="viewPDF" type="button" class="btn btn-link btn-sm" (click)="viewAppPDF(case)">View PDF</button></td>
              </tr>
            </ng-template>
            <ng-template *ngIf="applicationList" pTemplate="summary">
              <div class="row">
                <div class="col-md-2 offset-1" style="text-align: left;">Total # of applications: {{ applicationList.length }}</div>
                <span *ngIf="filterEventCount>0 && applicationList.length != filterEventCount" style="margin-left: 30px;"># of filtered items: {{filterEventCount}} </span>
              </div>
            </ng-template>
          </p-table>
            <!--  grid appears here
            <p-table #efileCases [columns]="cols" [value]="applicationList" [responsive]="true" [scrollable]="true" scrollHeight="450px" [(selection)]="selectedCases" dataKey="applicationId"  (onFilter)="onFilter($event, efileCases)" >
                <ng-template pTemplate="caption">

                    <div class="ui-table-globalfilter-container">
                        <input type="text" pInputText size="40" [(ngModel)]="filterOptions.filterText" placeholder="Global Filter" title="Enter text for which to search, then press ENTER key" (keyup.enter)="efileCases.filterGlobal($event.target.value, 'contains')" style="width:200px;">
                    </div>
                    &nbsp;&nbsp;&nbsp;
                    <strong>E-File Applications for {{this.myYear}}</strong>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="width: 7%;">{{ cols[0].header }}</th>
                        <th style="width: 15%;">{{ cols[1].header }}</th>
                        <th style="width: 7%;">{{ cols[2].header }}</th>
                        <th style="width: 10%;">{{ cols[3].header }}</th>
                        <th style="width: 7%;">{{ cols[4].header }}</th>
                        <th style="width: 15%;">{{ cols[5].header }}</th>
                        <th style="width: 12%;">{{ cols[6].header }}</th>
                        <th style="width: 5%;">{{ cols[7].header }}</th>
                        <th style="width: 5%;"></th>
                        <th style="width: 5%;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-case>
                    <tr>
                        <td style="width: 7%;">{{ case.dateUpdated | date:"MM/dd/yyyy" }}</td>
                        <td style="width: 15%"> {{case.username}}</td>
                        <td style="width: 7%"> {{case.filingStatus}}</td>
                        <td style="width: 10%;">{{ case.applicantName }}</td>
                        <td style="width: 7%;">{{ case.parcelNumber }}</td>
                        <td style="width: 15%;">{{ case.propertyLocationView }}</td>
                        <td style="width: 12%;">{{ case.agentName }}</td>
                        <td style="width: 5%;">{{ case.applicationNumber }}</td>
                        <td style="width: 5%;"><button id="viewApp" type="button" class="btn btn-link btn-sm" (click)="viewApplication(case)">View App</button></td>
                        <td style="width: 5%;"><button id="viewPDF" type="button" class="btn btn-link btn-sm" (click)="viewAppPDF(case)">View PDF</button></td>
                    </tr>
                </ng-template>
                <ng-template *ngIf="applicationList.length>0" pTemplate="summary">
                    <div class="row">
                        <div class="col-md-2 offset-1" style="text-align: left;"># of applications: {{ applicationList.length }}</div>
                        <span *ngIf="filterEventCount>0" style="margin-left: 30px;"># of filtered items: {{filterEventCount}} </span>
                    </div>
                </ng-template>
            </p-table>
             -->
        </div>

        <!-- Details Div-->
        <div *ngIf="displayState.detailsDiv" style="background-color: gainsboro; border: thin; border-radius: 5px;">
            <br />
            <efiling-details [efileId]='myEfileId' (changeEvent)='exitDetails()' ></efiling-details>
        </div>


        <!-- Error Message -->
        <div class="row">
            <div class="col-md-offset-3 col-md-9 text-danger" *ngIf="displayState.errorMessage!=''"><p>{{displayState.errorMessage}}</p>  </div>
        </div>
        <br />
        <br />

    </div>
</div>
